import { modelStore } from "@/store/model";
import { MediaVersion } from "@/types/mediaArtifact";
import { convertFilePathToUrl } from "./convertFilePathToUrl";

/**
 * 根据 task_id_list 创建 generating 状态的 MediaVersion
 * @param taskIdList 任务 ID 列表
 * @param toolType 工具类型
 * @param prompt 提示词
 * @param attachmentUrls 附件 URL 列表
 * @param modelValue 模型名称
 * @param imageSrc 图片源（用于预览）
 * @param dialogue 台词文本（可选，用于视频）
 * @param voiceId 声音 ID（可选，用于视频）
 * @returns MediaVersion 数组
 */
export function createGeneratingVersionsFromTaskIds(
  taskIdList: string[],
  prompt: string,
  attachmentUrls: string[],
  modelValue: string,
  dialogue: string = "",
  voiceId: string = ""
): MediaVersion[] {
  return taskIdList.map((taskId, index) => ({
    id: taskId,
    src: "",
    previewSrc: "",
    filePath: "",
    source: "generate",
    prompt,
    model: modelStore.getModelViewInfo(modelValue),
    attachmentList: attachmentUrls.map((item) => ({
      id: item || `attachment-${Math.random().toString(36).substring(2, 15)}`,
      type: "url",
      url: convertFilePathToUrl(item),
    })),
    status: "generating",
    createdTime: Date.now() + index,
    dialogue,
    voiceId,
  }));
}

/**
 * 合并和排序版本列表
 */
export function mergeAndSortVersions(
  generatedVersions: MediaVersion[],
  taskVersions: MediaVersion[],
  localGeneratingVersions: MediaVersion[]
): MediaVersion[] {
  const finalTaskVersions = taskVersions.filter(
    (taskVersion) =>
      !generatedVersions.some(
        (v) =>
          (v.filePath &&
            taskVersion.filePath &&
            v.filePath === taskVersion.filePath) ||
          v.id === taskVersion.id
      )
  );

  const finalLocalGeneratingVersions = localGeneratingVersions
    .filter(
      (manualVersion) =>
        !generatedVersions.some(
          (v) =>
            (v.filePath &&
              manualVersion.filePath &&
              v.filePath === manualVersion.filePath) ||
            v.id === manualVersion.id
        )
    )
    .filter(
      (manualVersion) =>
        !finalTaskVersions.some(
          (v) =>
            (v.filePath &&
              manualVersion.filePath &&
              v.filePath === manualVersion.filePath) ||
            v.id === manualVersion.id
        )
    );

  const finalVersions = [
    ...generatedVersions,
    ...finalTaskVersions,
    ...finalLocalGeneratingVersions,
  ];

  const generatingVersions = finalVersions.filter(
    (version) => version.status === "generating"
  );

  const otherVersions = finalVersions.filter(
    (version) => version.status !== "generating"
  );

  // 按创建时间降序排序
  return [
    ...generatingVersions.sort((a, b) => b.createdTime - a.createdTime),
    ...otherVersions.sort((a, b) => b.createdTime - a.createdTime),
  ];
}
